export default __webpack_public_path__ + "static/media/DownArrow.04ab1da7.svg";